<template >
  <div class="wrapper-result">
    <h1 class="h1Big">Результат прохождения</h1>

    <a-tabs
      @tabClick="handleTabClick"
    >
      <a-tab-pane
        v-for="o in membersQuizzes"
        :key="`${o.id}`"
      >
        <span slot="tab" >
          <a-icon v-if="membersQuizzes[o.id].commSkillsBar" type="solution" />
          <a-icon v-else type="clock-circle-o" />
          Тест №{{o.id}}
        </span>
<!-- <a-icon type="check-circle-o" /> -->
        <Loading :spinning="getMembersQuizzesLoading">
          <QuizResult
            v-if="membersQuizzes[o.id].commSkillsBar"
            :ptype="membersQuizzes[o.id].psyType"
            :commBarsData="membersQuizzes[o.id].commSkillsBar"
            :urlQuiz="urlQuiz+o.id"
          />
          <NoResults
            v-else
            :urlQuiz="urlQuiz+o.id"
            style="min-height: 1000px;"
          />
        </Loading>
          <!-- :skillsDescription="" -->
      </a-tab-pane>
    </a-tabs>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import BarGraph from '@/components/BarGraph'
import NoResults from './NoResults'
import QuizResult from './QuizResult'
import Loading from './Loading'

export default {
  name: 'Result',
  props: ['result'],
  components: {
    BarGraph,
    NoResults,
    Loading,
    QuizResult,
  },
  data() {
    return {
      urlQuiz: `https://sc.etuus.com/`,
      commBarsData: [],
      barGraphInitialData: [
        {
          label: 'Включенность',
          name: 'involvement',
          value: 5,
          color: ['#FFDE7F', 'rgba(255, 185, 104, 0.1)'],
        },
        {
          label: 'Осознанность',
          name: 'awareness',
          value: 5,
          color: ['#00D7A2', 'rgba(0, 215, 162, 0.1)'],
        },
        {
          label: 'Ясность',
          name: 'clarity',
          value: 5,
          color: ['#FF026F', 'rgba(255, 2, 111, 0.1)'],
        },
        {
          label: 'Гибкость мышления',
          name: 'mental_flexibility',
          value: 5,
          color: ['#2792FF', 'rgba(39, 146, 255, 0.1)'],
        },
        {
          label: 'Уверенность',
          name: 'anxiety',
          value: 5,
          color: ['#FFB967', 'rgba(255, 185, 103, 0.1)'],
        },
      ],
    }
  },
  created () {
  },
  methods: {
    async handleTabClick(quizId) {
      // await this.$store.dispatch('getMemberQuizzesResult', quizId)

    },
    updateBarGraphValue() {
      // this.currentMemberQuizzes.map(o => {})
      const barGraph = barGraphInitialData;
    }
  },
  computed: {
    ...mapState([
      'communicativeSkillsDescription',
      'currentMemberQuizzes',
      'membersQuizzes',
      'getMembersQuizzesLoading'
    ]),
  }
};
</script>

<style scoped lang='scss'>
@import '../../css/var.scss';

.wrapper-result {
  margin: 0 30px;
  max-width: 790px;
}

.title {
  @include titleStyles;
  font-size: 24px;
  margin: 0;
  line-height: 1.2;
  margin-bottom: 20px;

  @media (max-width: $mobile) {
    font-size: 32px;
    line-height: 1.3;
  }
}

.subtitle {
  font-family: $mainFont;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.5;
}

.loader {
  position: relative;

  &-text {
    text-align: center;
    display: block;
    margin-top: 10px;
    opacity: .7;
  }
}

.link {
  display: block;
  margin-bottom: 10px;
}

.copy-link {
  display: block;
}

</style>
